import { createWebHistory, createRouter, createWebHashHistory } from "vue-router";

import EcommercePage from "../pages/Dashboard/EcommercePage.vue";
import LMSCoursesPage from "../pages/Dashboard/LMSCoursesPage.vue";
import LoginPage from "../pages/Authentication/LoginPage.vue";
import RegisterPage from "../pages/Authentication/RegisterPage.vue";
import ForgotPasswordPage from "../pages/Authentication/ForgotPasswordPage.vue";
import ResetPasswordPage from "../pages/Authentication/ResetPasswordPage.vue";
import EmailConfirmationPage from "../pages/Authentication/EmailConfirmationPage.vue";
import StatistiqueGlobalPage from "@/pages/Etats/StatistiqueGlobalPage.vue";

import ErrorPage from "../pages/ErrorPage.vue";

import ConnectedAccountsPage from "../pages/PagesInner/ConnectedAccountsPage.vue";
import BlankPage from "../pages/BlankPage.vue";
import LogoutPage from "../pages/LogoutPage.vue";
import ListePermissionPage from "@/pages/Permission/ListePermissionPage.vue";
import AddRolePage from "@/pages/Role/AddRolePage.vue";
import EditRolePage from "@/pages/Role/EditRolePage.vue";
import ListeRolePage from "@/pages/Role/ListeRolePage.vue";
import ViewRolePage from "@/pages/Role/ViewRolePage.vue";
import AddUserPage from "@/pages/Users/AddUserPage.vue";
import EditUserPage from "@/pages/Users/EditUserPage.vue";
import ListeUserPage from "@/pages/Users/ListeUserPage.vue";
import ProfilePage from "../pages/PagesInner/ProfilePage.vue";

import ListeJournalConnexionPage from "@/pages/Journal/ListeJournalConnexionPage.vue";
import ListeJournalOperationPage from "@/pages/Journal/ListeJournalOperationPage.vue";
import ListeCategorieActivite from "@/pages/CategorieActivite/ListeCategorieActivitePage.vue";
import ListeMarche from "@/pages/Marche/ListeMarchePage.vue";
import ViewMarchePage from "@/pages/Marche/ViewMarchePage.vue";

import ListeSecteur from "@/pages/Secteur/ListeSecteurPage.vue";
import ListeService from "@/pages/Service/ListeServicePage.vue";
import ListeTypeEmplacement from "@/pages/TypeEmplacement/ListeTypeEmplacementPage.vue";
import ListeElementElectrique from "@/pages/ElementElectrique/ListeElementElectriquePage.vue";
import ListeActivite from "@/pages/Activite/ListeActivitePage.vue";


import ListePaiement from "@/pages/Paiement/ListePaiementPage.vue";
import ListeParametre from "@/pages/Parametre/ListeParametrePage.vue";
import ViewParametrePage from "@/pages/Parametre/ViewParametrePage.vue";


import ListeUsagerPage from "@/pages/Usager/ListeUsagerPage.vue";
import AddUsagerPage from "@/pages/Usager/AddUsagerPage.vue";
import EditUsagerPage from "@/pages/Usager/EditUsagerPage.vue";
import ViewUsagerPage from "@/pages/Usager/ViewUsagerPage.vue";

import ListeReclamationPage from "@/pages/Reclamation/ListeReclamationPage.vue";
import AddReclamationPage from "@/pages/Reclamation/AddReclamationPage.vue";
import EditReclamationPage from "@/pages/Reclamation/EditReclamationPage.vue";
import ViewReclamationPage from "@/pages/Reclamation/ViewReclamationPage.vue";



import ListeFacturePage from "@/pages/Facture/ListeFacturePage.vue";
import AddFacturePage from "@/pages/Facture/AddFacturePage.vue";
import AddFacture2Page from "@/pages/Facture/AddFacture2Page.vue";
import EditFacturePage from "@/pages/Facture/EditFacturePage.vue";

import ListeFactureSPage from "@/pages/FactureS/ListeFactureSPage.vue";
import AddFactureSPage from "@/pages/FactureS/AddFactureSPage.vue";
import EditFactureSPage from "@/pages/FactureS/EditFactureSPage.vue";

import ListePlacePage from "@/pages/Place/ListePlacePage.vue";
import AddPlacePage from "@/pages/Place/AddPlacePage.vue";
import EditPlacePage from "@/pages/Place/EditPlacePage.vue";
import ViewPlacePage from "@/pages/Place/ViewPlacePage.vue";


import { useAuthStore } from "@/services/auth";
import ApiService from "@/services/ApiService";
import ListeContratPage from "@/pages/Contrat/ListeContratPage.vue";
import ListeContratElementsPage from "@/pages/Contrat/ListeContratElementsPage.vue";
import ViewContratPage from "@/pages/Contrat/ViewContratPage.vue";
import AddContratPage from "@/pages/Contrat/AddContratPage.vue";
import GenererFacturePage from "@/pages/Facture/GenererFacturePage.vue";
import LandingPage from "@/pages/LandingPage/LandingPage.vue";
import ProcessPaiement from "@/pages/LandingPage/ProcessPaiement.vue";
import ImportationPlace from "@/components/Importation/ImportationPlace.vue";
import ImportationUsagerPage from "@/pages/Importation/ImportationUsagerPage.vue";
import ImportationContratPage from "@/pages/Importation/importationContratPage.vue";

import ListeGroupeDeTaxePage from "@/pages/GroupeDeTaxe/ListeGroupeDeTaxePage.vue";
import ModelContratPage from "@/pages/ModelContrat/ModelContratPage.vue";
import ImportationElementElectrique from "@/pages/Importation/ImportationElementElectrique.vue";
import ImportationFacturesElectriciteExcelPage from "@/pages/Importation/ImportationFacturesElectriciteExcelPage.vue";
import EditContratPage from "@/pages/Contrat/EditContratPage.vue";
import ListePaiementAutreRecettePage from "@/pages/PaiementRecette/ListePaiementAutreRecettePage.vue";
import PaiementAutreRecettesPage from "@/pages/PaiementRecette/PaiementAutreRecettesPage.vue";
import EtatContratParUsagerPage from "@/pages/Etats/EtatContratParUsagerPage.vue";
/*import EditFacturePage from "@/pages/Facture/EditFacturePage.vue";
import ListeFacturePage from "@/pages/Facture/ListeFacturePage.vue";
import GenererFacturePage from "@/pages/Facture/GenererFacturePage.vue";
import AddFacturePage from "@/pages/Facture/AddFacturePage.vue";*/


const routes = [
  {
    path: "/",
    redirect: "/e-anagem",
    component: () => import("@/layouts/LandingV.vue"),
    children: [
      {
        path: "/e-anagem",
        name: "LandingPage",
        component: LandingPage,
      },
      {
        path: "/e-processus",
        name: "ProcessPaiement",
        component: ProcessPaiement,
      },
    ],
  },
  {
    path: "/",
    redirect: "/login",
    component: () => import("@/layouts/MainLayout.vue"),
    meta: {
      middleware: "auth",
    },
    children: [
      {
        path: "/tableau_bord",
        name: "tableauBordPage",
        component: EcommercePage,
      },
      /*{
        path: "/tableau_bord1",
        name: "tableauBordPage1",
        component: LMSCoursesPage,
      },*/
      // {
      //   path: "/users-list",
      //   name: "UsersListPage",
      //   component: UsersListPage,
      // },
      // {
      //   path: "/add-user",
      //   name: "AddUserPage",
      //   component: AddUserPage,
      // },

      /*{
        path: "/etat-stat-global",
        name: "StatistiqueGlobalPage",
        component: StatistiqueGlobalPage,
      },*/
      {
        path: "/liste-place",
        name: "ListePlacePage",
        component: ListePlacePage,
      },
      {
        path: "/ajouter-place",
        name: "AddPlacePage",
        component: AddPlacePage,
      },
      {
        path: "/modifier-place/:id",
        name: "EditPlacePage",
        component: EditPlacePage,
      },
      {
        path: "/detail-place/:id",
        name: "ViewPlacePage",
        component: ViewPlacePage,
      },

      {
        path: "/liste-privileges",
        name: "ListePermissionPage",
        component: ListePermissionPage,
      },

      {
        path: "/liste-facture",
        name: "ListeFacturePage",
        component: ListeFacturePage,
      },
      {
        path: "/ajouter-facture",
        name: "AddFacturePage",
        component: AddFacturePage,
      },
      {
        path: "/ajouter-facture2",
        name: "AddFacture2Page",
        component: AddFacture2Page,
      },
      {
        path: "/modifier-facture/:id",
        name: "EditFacturePage",
        component: EditFacturePage,
      },
      
      {
        path: "/liste-factureS",
        name: "ListeFactureSPage",
        component: ListeFactureSPage,
      },
      {
        path: "/ajouter-factureS",
        name: "AddFactureSPage",
        component: AddFactureSPage,
      },
      
      {
        path: "/modifier-factureS/:id",
        name: "EditFactureSPage",
        component: EditFactureSPage,
      },


      {
        path: "/liste-usager",
        name: "ListeUsagerPage",
        component: ListeUsagerPage,
      },

      {
        path: "/ajouter-usager",
        name: "AddUsagerPage",
        component: AddUsagerPage,
      },
      {
        path: "/modifier-usager/:id",
        name: "EditUsagerPage",
        component: EditUsagerPage,
      },
      {
        path: "/view-usager/:id",
        name: "ViewUsagerPage",
        component: ViewUsagerPage,
      },

      {
        path: "/liste-reclamation",
        name: "ListeReclamationPage",
        component: ListeReclamationPage,
      },

      {
        path: "/ajouter-reclamation",
        name: "AddReclamationPage",
        component: AddReclamationPage,
      },
      {
        path: "/modifier-reclamation/:id",
        name: "EditReclamationPage",
        component: EditReclamationPage,
      },
      {
        path: "/view-reclamation/:id",
        name: "ViewReclamationPage",
        component: ViewReclamationPage,
      },
      {
        path: "/ajouter-role",
        name: "AddRolePage",
        component: AddRolePage,
      },
      {
        path: "/modifier-role/:id",
        name: "EditRolePage",
        component: EditRolePage,
      },
      {
        path: "/importation-place",
        name: "ImportationPlace",
        component: ImportationPlace,
      },
      {
        path: "/importation-marchand",
        name: "ImportationUsagerPage",
        component: ImportationUsagerPage,
      },
      {
        path: "/importation-element-electrique",
        name: "ImportationElementElectrique",
        component: ImportationElementElectrique,
      },
      {
        path: "/importation-factures-electricite-excel",
        name: "ImportationFacturesElectriciteExcelPage",
        component: ImportationFacturesElectriciteExcelPage,
      },
      {
        path: "/importation-contrat",
        name: "ImportationContratPage",
        component: ImportationContratPage,
      },
      {
        path: "/liste-roles",
        name: "ListeRolePage",
        component: ListeRolePage,
      },
      {
        path: "/view-role/:id",
        name: "ViewRolePage",
        component: ViewRolePage,
      },
      {
        path: "/liste-journal-connexion",
        name: "ListeJournalConnexionPage",
        component: ListeJournalConnexionPage,
      },
      {
        path: "/liste-journal-operation",
        name: "ListeJournalOperationPage",
        component: ListeJournalOperationPage,
      },
      {
        path: "/liste-categorie-activite",
        name: "ListeCategorieActivitePage",
        component: ListeCategorieActivite,
      },

      {
        path: "/liste-activite",
        name: "ListeActivitePage",
        component: ListeActivite,
      },

      {
        path: "/liste-marche",
        name: "ListeMarchePage",
        component: ListeMarche,
      },
      {
        path: "/view-marche/:id",
        name: "ViewMarchePage",
        component: ViewMarchePage,
      },
      {
        path: "/liste-parametre",
        name: "ListeParametrePage",
        component: ListeParametre,
      },
      {
        path: "/view-parametre/:id",
        name: "ViewParametrePage",
        component: ViewParametrePage,
      },
      {
        path: "/liste-secteur",
        name: "ListeSecteurPage",
        component: ListeSecteur,
      },
      {
        path: "/liste-service",
        name: "ListeServicePage",
        component: ListeService,
      },
      {
        path: "/liste-groupe_taxe",
        name: "ListeGroupeDeTaxePage",
        component: ListeGroupeDeTaxePage,
      },
      {
        path: "/liste-element-electrique",
        name: "ListeElementElectriquePage",
        component: ListeElementElectrique,
      },
      {
        path: "/liste-type-emplacement",
        name: "ListeTypeEmplacementPage",
        component: ListeTypeEmplacement,
      },
      {
        path: "/liste-paiement",
        name: "ListePaiementPage",
        component: ListePaiement,
      },
      {
        path: "/liste-paiement-autre-recette",
        name: "ListePaiementAutreRecettePage",
        component: ListePaiementAutreRecettePage,
      },
      {
        path: "/ajouter-paiement-autre-recette",
        name: "PaiementAutreRecettesPage",
        component: PaiementAutreRecettesPage,
      },
      {
        path: "/point-places",
        name: "EtatContratParUsager",
        component: EtatContratParUsagerPage,
      },
      {
        path: "/ajouter-user",
        name: "AddUserPage",
        component: AddUserPage,
      },
      {
        path: "/modifier-user/:id",
        name: "EditUserPage",
        component: EditUserPage,
      },
      {
        path: "/liste-users",
        name: "ListeUserPage",
        component: ListeUserPage,
      },
      {
        path: "/ajout-model-contract",
        name: "ModelContratPage",
        component: ModelContratPage,
      },
      {
        path: "/ajouter-contrat",
        name: "AddContratPage",
        component: AddContratPage,
      },
      {
        path: "/view-contrat/:id",
        name: "ViewContratPage",
        component: ViewContratPage,
      },
      {
        path: "/modifier-contrat/:id",
        name: "EditContratPage",
        component: EditContratPage,
      },
      {
        path: "/liste-contrats",
        name: "ListeContratPage",
        component: ListeContratPage,
      },
      {
        path: "/liste-contrat-elements",
        name: "ListeContratElementsPage",
        component: ListeContratElementsPage,
      },
      {
        path: "/generer-facture",
        name: "GenererFacturePage",
        component: GenererFacturePage,
      },
      /* {
         path: "/ajouter-facture",
         name: "AddFacturePage",
         component: AddFacturePage,
       },
       {
         path: "/generer-facture",
         name: "GenererFacturePage",
         component: GenererFacturePage,
       },
       {
         path: "/modifier-facture/:id",
         name: "EditFacturePage",
         component: EditFacturePage,
       },
       {
         path: "/liste-factures",
         name: "ListeFacturePage",
         component: ListeFacturePage,
       },*/
      {
        path: "/profile",
        name: "ProfilePage",
        component: ProfilePage,
      },

    ],
  },
  {
    path: "/",
    redirect: "/login",
    component: () => import("@/layouts/AuthLayout.vue"),
    children: [
      {
        path: "/login",
        name: "LoginPage",
        component: LoginPage,
      },
      {
        path: "/register",
        name: "RegisterPage",
        component: RegisterPage,
      },
      {
        path: "/forgot-password",
        name: "ForgotPasswordPage",
        component: ForgotPasswordPage,
      },
      {
        path: "/reset-password",
        name: "ResetPasswordPage",
        component: ResetPasswordPage,
      },
      {
        path: "/email-confirmation",
        name: "EmailConfirmationPage",
        component: EmailConfirmationPage,
      },
      {
        path: "/connected-accounts",
        name: "ConnectedAccountsPage",
        component: ConnectedAccountsPage,
      },

      {
        path: "/logout",
        name: "LogoutPage",
        component: LogoutPage,
      },
    ],
  },
  { path: "/:pathMatch(.*)*", name: "ErrorPage", component: ErrorPage },
];

const router = createRouter({
  //history: createWebHistory(),
  history: createWebHashHistory(),
  linkExactActiveClass: "active",
  routes: routes,
  scrollBehavior() {
    return { top: 0, behavior: "smooth" };
  },
});

router.beforeEach(async (to, from, next) => {
  const authStore = useAuthStore();
  await authStore.verifyAuth();
  if (to.meta.middleware == "auth") {
    ApiService.setHeader();
    if (authStore.isAuthenticated) {
      next();
    } else {
    next({ name: "LoginPage" });
      // next()
    }
  } else {
    next();
  }
  // Scroll page to top on every route change
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: "smooth",
  });
});


export default router;